import React, { useState } from "react"
import { useHistory } from "react-router"

type GoBack = (previous?: string) => void
type UseAboutyouFlowReturn = {
  wentBack: boolean
  goBack: GoBack
  onFlowComplete: () => void
}

const AboutYouFlowContext = React.createContext(null)
export const useAboutYouFlowControls = (): UseAboutyouFlowReturn => React.useContext(AboutYouFlowContext)

export function AboutYouFlowContextProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const history = useHistory()
  const [wentBack, setWentBack] = useState(false)

  function goBack(previous?: string): void {
    setWentBack(true)
    if (previous) {
      history.push(previous)
    } else {
      history.goBack()
    }
  }

  function onFlowComplete(): void {
    // this is to make it so that when we go back from the journey page, we don't have issues
    setWentBack(true)
  }

  return (
    <AboutYouFlowContext.Provider
      value={{
        wentBack,
        goBack,
        onFlowComplete
      }}
    >
      {children}
    </AboutYouFlowContext.Provider>
  )
}
